<div
    class="cmps-cdk-p-0dot75 cmps-cdk-bg-color-unknown-100 cmps-cdk-border-t-width-1px cmps-cdk-border-r-width-1px cmps-cdk-border-b-width-1p cmps-cdk-border-l-width-4px cmps-cdk-border-solid cmps-cdk-border-t-color-unknown-107 cmps-cdk-border-r-color-unknown-107 cmps-cdk-border-b-color-unknown-107 cmps-cdk-border-l-color-unknown-106 cmps-cdk-border-radius-4p"
>
    <div class="cmps-cdk-font-bold cmps-cdk-text-uppercase cmps-cdk-mb-0dot5">
        New Phrase
    </div>
    <input
        type="text"
        class="cmps-cdk-d-block cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-unknown-102 cmps-cdk-border-radius-4px cmps-cdk-px-0dot5 cmps-cdk-py-0dot25 cmps-cdk-w-100pct cmps-cdk-line-height-normal cmps-cdk-mb-1 cmps-cdk-outline-0"
        placeholder="What phrase do you want to land?"
        [(ngModel)]="_value.phrase"
    />

    <div class="cmps-cdk-d-flex cmps-cdk-align-items-center">
        <div>
            <cmps-checkbox>Save for future use</cmps-checkbox>
        </div>
        <div class="cmps-cdk-flex-grow-1"></div>
        <div class="cmps-cdk-d-flex cmps-cdk-justify-content-flex-end">
            <div>
                <button
                    type="button"
                    class="cmps-cdk-bg-color-unknown-100 cmps-cdk-border-width-0p cmps-cdk-color-unknown-109 cmps-cdk-font-bold cmps-cdk-min-h-34p cmps-cdk-px-1 cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center focus:not:focus-visible:cmps-cdk-outline-0"
                    (click)="_onCancelClick()"
                >
                    <span class="cmps-cdk-line-clamp-1">✕ Cancel</span>
                </button>
            </div>
            <div class="cmps-cdk-pl-0dot5">
                <button
                    type="button"
                    class="cmps-cdk-bg-color-blue-100 cmps-cdk-border-radius-4px cmps-cdk-border-width-0p cmps-cdk-color-white cmps-cdk-font-bold cmps-cdk-min-h-34p cmps-cdk-px-1 cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center focus:not:focus-visible:cmps-cdk-outline-0"
                    (click)="_onSaveClick()"
                >
                    <span class="cmps-cdk-line-clamp-1">Save</span>
                </button>
            </div>
        </div>
    </div>
</div>
